"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MainMenu = class MainMenu extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    get displayTestBadge() {
        if (this.loaded) {
            return _.includes(this.$app.document.location.hostname, 'test');
        }
        return null;
    }
    get displayDevBadge() {
        if (this.loaded) {
            return _.includes(this.$app.document.location.hostname, 'local');
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_4446976243747050_showModal_1702_getActionArgs($event) {
        return {
            name: "CreateInvoice",
            props: {
                invoiceKind: "outgoing",
            },
        };
    }
    async evh_4446976243747050_clickPrevent(event, scope) {
        return await this.actions.evh_4446976243747050_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5794187517758435_showModal_1704_getActionArgs($event) {
        return {
            name: "CreateInvoice",
            props: {
                invoiceKind: "incoming",
            },
        };
    }
    async evh_5794187517758435_clickPrevent(event, scope) {
        return await this.actions.evh_5794187517758435_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_8440793417118356_showModal_1706_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "cash_book",
                transactionType: "deposit",
            },
        };
    }
    async evh_8440793417118356_clickPrevent(event, scope) {
        return await this.actions.evh_8440793417118356_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_6201675214105229_showModal_1708_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "cash_book",
                transactionType: "payment",
            },
        };
    }
    async evh_6201675214105229_clickPrevent(event, scope) {
        return await this.actions.evh_6201675214105229_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_6373990564425123_showModal_1710_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                transactionKind: "bank",
            },
        };
    }
    async evh_6373990564425123_clickPrevent(event, scope) {
        return await this.actions.evh_6373990564425123_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_8819772728062230_showModal_1712_getActionArgs($event) {
        return {
            name: "AccountStatementReport",
        };
    }
    async evh_8819772728062230_clickPrevent(event, scope) {
        return await this.actions.evh_8819772728062230_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_1886107574314164_showModal_1714_getActionArgs($event) {
        return {
            name: "MCreateFixedAsset",
            props: {
                assetType: "general",
            },
        };
    }
    async evh_1886107574314164_clickPrevent(event, scope) {
        return await this.actions.evh_1886107574314164_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_7260361660686930_showModal_1716_getActionArgs($event) {
        return {
            name: "MCreateFixedAsset",
            props: {
                assetType: "waste_bin",
            },
        };
    }
    async evh_7260361660686930_clickPrevent(event, scope) {
        return await this.actions.evh_7260361660686930_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5449511595610967_showModal_1718_getActionArgs($event) {
        return {
            name: "CreateMeter",
        };
    }
    async evh_5449511595610967_clickPrevent(event, scope) {
        return await this.actions.evh_5449511595610967_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5934241105726385_showModal_1720_getActionArgs($event) {
        return {
            name: "ReplaceMeter",
        };
    }
    async evh_5934241105726385_clickPrevent(event, scope) {
        return await this.actions.evh_5934241105726385_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_7807097906137782_showModal_1722_getActionArgs($event) {
        return {
            name: "MeterDataExchange",
        };
    }
    async evh_7807097906137782_clickPrevent(event, scope) {
        return await this.actions.evh_7807097906137782_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2338624680052783_showModal_1724_getActionArgs($event) {
        return {
            name: "CreateContract",
        };
    }
    async evh_2338624680052783_clickPrevent(event, scope) {
        return await this.actions.evh_2338624680052783_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_8760507335979244_showModal_1726_getActionArgs($event) {
        return {
            name: "BillingRules",
        };
    }
    async evh_8760507335979244_clickPrevent(event, scope) {
        return await this.actions.evh_8760507335979244_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2596033535867385_showModal_1728_getActionArgs($event) {
        return {
            name: "Worksheet",
            props: {
                size: "lg",
            },
        };
    }
    async evh_2596033535867385_clickPrevent(event, scope) {
        return await this.actions.evh_2596033535867385_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2660996057968802_showModal_1730_getActionArgs($event) {
        return {
            name: "CreateProduct",
        };
    }
    async evh_2660996057968802_clickPrevent(event, scope) {
        return await this.actions.evh_2660996057968802_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2344870777941005_showModal_1732_getActionArgs($event) {
        return {
            name: "Tariffs",
        };
    }
    async evh_2344870777941005_clickPrevent(event, scope) {
        return await this.actions.evh_2344870777941005_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2858245741222179_showModal_1734_getActionArgs($event) {
        return {
            name: "CreateRental",
        };
    }
    async evh_2858245741222179_clickPrevent(event, scope) {
        return await this.actions.evh_2858245741222179_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_6767246748725383_showModal_1736_getActionArgs($event) {
        return {
            name: "CreateProject",
        };
    }
    async evh_6767246748725383_clickPrevent(event, scope) {
        return await this.actions.evh_6767246748725383_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_6779411695051524_showModal_1738_getActionArgs($event) {
        return {
            name: "CreateProperty",
        };
    }
    async evh_6779411695051524_clickPrevent(event, scope) {
        return await this.actions.evh_6779411695051524_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_173976191917830_showModal_1740_getActionArgs($event) {
        return {
            name: "CreateCompany",
            props: {
                role: "partner",
            },
        };
    }
    async evh_173976191917830_clickPrevent(event, scope) {
        return await this.actions.evh_173976191917830_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5091029904152798_showModal_1742_getActionArgs($event) {
        return {
            name: "CreateCompany",
            props: {
                role: "own",
            },
        };
    }
    async evh_5091029904152798_clickPrevent(event, scope) {
        return await this.actions.evh_5091029904152798_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_298118714321807_script_1744_getActionArgs_value($event) {
        this.$app.toggleConfirmPageClose($event);
    }
    async act_298118714321807_script_1744_getActionArgs($event) {
        return {
            value: () => this.act_298118714321807_script_1744_getActionArgs_value($event),
        };
    }
    async evh_298118714321807_change(event, scope) {
        return await this.actions.evh_298118714321807_change.executeFromDOM(this, event, scope);
    }
    async act_7106235911078350_logout_1746_getActionArgs($event) {
        return {};
    }
    async evh_7106235911078350_clickPrevent(event, scope) {
        return await this.actions.evh_7106235911078350_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_5361165673534032_showModal_1748_getActionArgs($event) {
        return {
            name: "AboutModal",
        };
    }
    async evh_5361165673534032_clickPrevent(event, scope) {
        return await this.actions.evh_5361165673534032_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_1700 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_1699 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_1700,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_1699],
        });
        const act_4446976243747050_showModal_1702 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4446976243747050_showModal_1702_getActionArgs,
            events: [],
        });
        const evh_4446976243747050_clickPrevent_1701 = new core_1.actions.EventHandlerImpl({
            action: act_4446976243747050_showModal_1702,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_4446976243747050_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4446976243747050_clickPrevent_1701],
        });
        const act_5794187517758435_showModal_1704 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5794187517758435_showModal_1704_getActionArgs,
            events: [],
        });
        const evh_5794187517758435_clickPrevent_1703 = new core_1.actions.EventHandlerImpl({
            action: act_5794187517758435_showModal_1704,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_5794187517758435_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5794187517758435_clickPrevent_1703],
        });
        const act_8440793417118356_showModal_1706 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8440793417118356_showModal_1706_getActionArgs,
            events: [],
        });
        const evh_8440793417118356_clickPrevent_1705 = new core_1.actions.EventHandlerImpl({
            action: act_8440793417118356_showModal_1706,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_8440793417118356_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8440793417118356_clickPrevent_1705],
        });
        const act_6201675214105229_showModal_1708 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6201675214105229_showModal_1708_getActionArgs,
            events: [],
        });
        const evh_6201675214105229_clickPrevent_1707 = new core_1.actions.EventHandlerImpl({
            action: act_6201675214105229_showModal_1708,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_6201675214105229_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6201675214105229_clickPrevent_1707],
        });
        const act_6373990564425123_showModal_1710 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6373990564425123_showModal_1710_getActionArgs,
            events: [],
        });
        const evh_6373990564425123_clickPrevent_1709 = new core_1.actions.EventHandlerImpl({
            action: act_6373990564425123_showModal_1710,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_6373990564425123_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6373990564425123_clickPrevent_1709],
        });
        const act_8819772728062230_showModal_1712 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8819772728062230_showModal_1712_getActionArgs,
            events: [],
        });
        const evh_8819772728062230_clickPrevent_1711 = new core_1.actions.EventHandlerImpl({
            action: act_8819772728062230_showModal_1712,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_8819772728062230_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8819772728062230_clickPrevent_1711],
        });
        const act_1886107574314164_showModal_1714 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1886107574314164_showModal_1714_getActionArgs,
            events: [],
        });
        const evh_1886107574314164_clickPrevent_1713 = new core_1.actions.EventHandlerImpl({
            action: act_1886107574314164_showModal_1714,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_1886107574314164_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1886107574314164_clickPrevent_1713],
        });
        const act_7260361660686930_showModal_1716 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7260361660686930_showModal_1716_getActionArgs,
            events: [],
        });
        const evh_7260361660686930_clickPrevent_1715 = new core_1.actions.EventHandlerImpl({
            action: act_7260361660686930_showModal_1716,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_7260361660686930_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7260361660686930_clickPrevent_1715],
        });
        const act_5449511595610967_showModal_1718 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5449511595610967_showModal_1718_getActionArgs,
            events: [],
        });
        const evh_5449511595610967_clickPrevent_1717 = new core_1.actions.EventHandlerImpl({
            action: act_5449511595610967_showModal_1718,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_5449511595610967_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5449511595610967_clickPrevent_1717],
        });
        const act_5934241105726385_showModal_1720 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5934241105726385_showModal_1720_getActionArgs,
            events: [],
        });
        const evh_5934241105726385_clickPrevent_1719 = new core_1.actions.EventHandlerImpl({
            action: act_5934241105726385_showModal_1720,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_5934241105726385_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5934241105726385_clickPrevent_1719],
        });
        const act_7807097906137782_showModal_1722 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7807097906137782_showModal_1722_getActionArgs,
            events: [],
        });
        const evh_7807097906137782_clickPrevent_1721 = new core_1.actions.EventHandlerImpl({
            action: act_7807097906137782_showModal_1722,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_7807097906137782_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7807097906137782_clickPrevent_1721],
        });
        const act_2338624680052783_showModal_1724 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2338624680052783_showModal_1724_getActionArgs,
            events: [],
        });
        const evh_2338624680052783_clickPrevent_1723 = new core_1.actions.EventHandlerImpl({
            action: act_2338624680052783_showModal_1724,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2338624680052783_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2338624680052783_clickPrevent_1723],
        });
        const act_8760507335979244_showModal_1726 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8760507335979244_showModal_1726_getActionArgs,
            events: [],
        });
        const evh_8760507335979244_clickPrevent_1725 = new core_1.actions.EventHandlerImpl({
            action: act_8760507335979244_showModal_1726,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_8760507335979244_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8760507335979244_clickPrevent_1725],
        });
        const act_2596033535867385_showModal_1728 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2596033535867385_showModal_1728_getActionArgs,
            events: [],
        });
        const evh_2596033535867385_clickPrevent_1727 = new core_1.actions.EventHandlerImpl({
            action: act_2596033535867385_showModal_1728,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2596033535867385_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2596033535867385_clickPrevent_1727],
        });
        const act_2660996057968802_showModal_1730 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2660996057968802_showModal_1730_getActionArgs,
            events: [],
        });
        const evh_2660996057968802_clickPrevent_1729 = new core_1.actions.EventHandlerImpl({
            action: act_2660996057968802_showModal_1730,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2660996057968802_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2660996057968802_clickPrevent_1729],
        });
        const act_2344870777941005_showModal_1732 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2344870777941005_showModal_1732_getActionArgs,
            events: [],
        });
        const evh_2344870777941005_clickPrevent_1731 = new core_1.actions.EventHandlerImpl({
            action: act_2344870777941005_showModal_1732,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2344870777941005_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2344870777941005_clickPrevent_1731],
        });
        const act_2858245741222179_showModal_1734 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2858245741222179_showModal_1734_getActionArgs,
            events: [],
        });
        const evh_2858245741222179_clickPrevent_1733 = new core_1.actions.EventHandlerImpl({
            action: act_2858245741222179_showModal_1734,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2858245741222179_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2858245741222179_clickPrevent_1733],
        });
        const act_6767246748725383_showModal_1736 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6767246748725383_showModal_1736_getActionArgs,
            events: [],
        });
        const evh_6767246748725383_clickPrevent_1735 = new core_1.actions.EventHandlerImpl({
            action: act_6767246748725383_showModal_1736,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_6767246748725383_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6767246748725383_clickPrevent_1735],
        });
        const act_6779411695051524_showModal_1738 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6779411695051524_showModal_1738_getActionArgs,
            events: [],
        });
        const evh_6779411695051524_clickPrevent_1737 = new core_1.actions.EventHandlerImpl({
            action: act_6779411695051524_showModal_1738,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_6779411695051524_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6779411695051524_clickPrevent_1737],
        });
        const act_173976191917830_showModal_1740 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_173976191917830_showModal_1740_getActionArgs,
            events: [],
        });
        const evh_173976191917830_clickPrevent_1739 = new core_1.actions.EventHandlerImpl({
            action: act_173976191917830_showModal_1740,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_173976191917830_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_173976191917830_clickPrevent_1739],
        });
        const act_5091029904152798_showModal_1742 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5091029904152798_showModal_1742_getActionArgs,
            events: [],
        });
        const evh_5091029904152798_clickPrevent_1741 = new core_1.actions.EventHandlerImpl({
            action: act_5091029904152798_showModal_1742,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_5091029904152798_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5091029904152798_clickPrevent_1741],
        });
        const act_298118714321807_script_1744 = new core_1.actions.ScriptAction({
            actionArgs: this.act_298118714321807_script_1744_getActionArgs,
            events: [],
        });
        const evh_298118714321807_change_1743 = new core_1.actions.EventHandlerImpl({
            action: act_298118714321807_script_1744,
            event: "change",
            displayName: "script",
        });
        const evh_298118714321807_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_298118714321807_change_1743],
        });
        const act_7106235911078350_logout_1746 = new core_1.actions.LogoutAction({
            actionArgs: this.act_7106235911078350_logout_1746_getActionArgs,
            events: [],
        });
        const evh_7106235911078350_clickPrevent_1745 = new core_1.actions.EventHandlerImpl({
            action: act_7106235911078350_logout_1746,
            event: "click.prevent",
            displayName: "logout",
        });
        const evh_7106235911078350_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7106235911078350_clickPrevent_1745],
        });
        const act_5361165673534032_showModal_1748 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5361165673534032_showModal_1748_getActionArgs,
            events: [],
        });
        const evh_5361165673534032_clickPrevent_1747 = new core_1.actions.EventHandlerImpl({
            action: act_5361165673534032_showModal_1748,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_5361165673534032_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5361165673534032_clickPrevent_1747],
        });
        return {
            act_7315092382398562_reloadComponentData_1700,
            evh_7315092382398562_reload_1699,
            evh_7315092382398562_reload,
            act_4446976243747050_showModal_1702,
            evh_4446976243747050_clickPrevent_1701,
            evh_4446976243747050_clickPrevent,
            act_5794187517758435_showModal_1704,
            evh_5794187517758435_clickPrevent_1703,
            evh_5794187517758435_clickPrevent,
            act_8440793417118356_showModal_1706,
            evh_8440793417118356_clickPrevent_1705,
            evh_8440793417118356_clickPrevent,
            act_6201675214105229_showModal_1708,
            evh_6201675214105229_clickPrevent_1707,
            evh_6201675214105229_clickPrevent,
            act_6373990564425123_showModal_1710,
            evh_6373990564425123_clickPrevent_1709,
            evh_6373990564425123_clickPrevent,
            act_8819772728062230_showModal_1712,
            evh_8819772728062230_clickPrevent_1711,
            evh_8819772728062230_clickPrevent,
            act_1886107574314164_showModal_1714,
            evh_1886107574314164_clickPrevent_1713,
            evh_1886107574314164_clickPrevent,
            act_7260361660686930_showModal_1716,
            evh_7260361660686930_clickPrevent_1715,
            evh_7260361660686930_clickPrevent,
            act_5449511595610967_showModal_1718,
            evh_5449511595610967_clickPrevent_1717,
            evh_5449511595610967_clickPrevent,
            act_5934241105726385_showModal_1720,
            evh_5934241105726385_clickPrevent_1719,
            evh_5934241105726385_clickPrevent,
            act_7807097906137782_showModal_1722,
            evh_7807097906137782_clickPrevent_1721,
            evh_7807097906137782_clickPrevent,
            act_2338624680052783_showModal_1724,
            evh_2338624680052783_clickPrevent_1723,
            evh_2338624680052783_clickPrevent,
            act_8760507335979244_showModal_1726,
            evh_8760507335979244_clickPrevent_1725,
            evh_8760507335979244_clickPrevent,
            act_2596033535867385_showModal_1728,
            evh_2596033535867385_clickPrevent_1727,
            evh_2596033535867385_clickPrevent,
            act_2660996057968802_showModal_1730,
            evh_2660996057968802_clickPrevent_1729,
            evh_2660996057968802_clickPrevent,
            act_2344870777941005_showModal_1732,
            evh_2344870777941005_clickPrevent_1731,
            evh_2344870777941005_clickPrevent,
            act_2858245741222179_showModal_1734,
            evh_2858245741222179_clickPrevent_1733,
            evh_2858245741222179_clickPrevent,
            act_6767246748725383_showModal_1736,
            evh_6767246748725383_clickPrevent_1735,
            evh_6767246748725383_clickPrevent,
            act_6779411695051524_showModal_1738,
            evh_6779411695051524_clickPrevent_1737,
            evh_6779411695051524_clickPrevent,
            act_173976191917830_showModal_1740,
            evh_173976191917830_clickPrevent_1739,
            evh_173976191917830_clickPrevent,
            act_5091029904152798_showModal_1742,
            evh_5091029904152798_clickPrevent_1741,
            evh_5091029904152798_clickPrevent,
            act_298118714321807_script_1744,
            evh_298118714321807_change_1743,
            evh_298118714321807_change,
            act_7106235911078350_logout_1746,
            evh_7106235911078350_clickPrevent_1745,
            evh_7106235911078350_clickPrevent,
            act_5361165673534032_showModal_1748,
            evh_5361165673534032_clickPrevent_1747,
            evh_5361165673534032_clickPrevent,
        };
    }
};
MainMenu = __decorate([
    (0, vue_property_decorator_1.Component)()
], MainMenu);
exports.default = MainMenu;
vue_property_decorator_1.Vue.component("MainMenu", MainMenu);
